import Styled from 'styled-components';

const FIT_CONTENT = 'fit-content';
const colorPalette = (props) => props.theme.colors.BLACK;
const PromotionContainer = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  ${(props) =>
    props.className === 'isPDP'
      ? `width: 82%;`
      : `width: ${props.isTileRedesignAB ? FIT_CONTENT : null};`}

  ${(props) =>
    props.className !== 'isPDP' && props.isTileRedesignAB
      ? `
    gap: 4px;
    padding: 6px 2px;
    margin: 0;
    @media ${props.theme.mediaQuery.smallOnly} {
      max-width: calc(100% - 34px);
      ${
        props.fromStoreSpecialsCarousel
          ? `margin-top: 7px;
          padding: 3px 2px;
      `
          : ''
      }
    }
    max-width: calc(100% - 44px);

  `
      : null}

  border-radius: ${(props) =>
    props.isTileRedesignAB ? '0px' : props.theme.spacing.ELEM_SPACING.XS_6};
    height: auto;
  background: ${(props) => {
    return props.theme.colors.PRIMARY.COLOR4;
  }};
  ${(props) =>
    props.className === 'isPDP'
      ? `padding: ${props.theme.spacing.ELEM_SPACING.XS};
       padding-bottom: ${props.theme.spacing.ELEM_SPACING.XS_1};
       margin-top: ${props.theme.spacing.ELEM_SPACING.MED};
       margin-bottom: 0px;
      `
      : null}

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    ${(props) =>
      props.className === 'isPDP'
        ? `width: 96%;
      `
        : null}
  }

  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    ${(props) =>
      props.className === 'isPDP'
        ? `width: 93%;
      padding: ${props.theme.spacing.ELEM_SPACING.XS_6};
      padding-bottom: ${props.theme.spacing.ELEM_SPACING.XS_1};
      margin-bottom:  ${props.theme.spacing.ELEM_SPACING.SM};
      `
        : null}

  ${(props) =>
    props.className !== 'isPDP' && !props.isTileRedesignAB
      ? `width: 91%;
  `
      : null}

  }

  .promo-ab {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy1}px;
    }

    line-height: 14px;
    color: ${(props) => props.theme.colors.BLACK};
    font-weight: 500;
    cursor: pointer;
  }

  .promotion-header {
    display: flex;
    align-items: center;
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    }
  }
  .best-offers {
    color: ${colorPalette};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
  }
  .promo-list-item {
    display: flex;
    align-items: flex-start;
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }
  .promo-list-item-margin-top {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }
  .icon {
    margin-right: ${(props) =>
      props.className === 'isPDP'
        ? props.theme.spacing.ELEM_SPACING.SM
        : props.theme.spacing.ELEM_SPACING.XS};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
      margin-right: ${(props) =>
        props.className === 'isPDP'
          ? props.theme.spacing.ELEM_SPACING.XS_1
          : props.theme.spacing.ELEM_SPACING.XXS};
    }
  }
  .icon_invisible {
    visibility: hidden;
  }
  .icon_visible {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    visibility: visible;
  }
  .underLine {
    text-decoration: underline;
    text-underline-offset: 3px;
  }.promo_message_anchor {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    display: flex;
    text-align: left;
    font-size: ${(props) =>
      props.className === 'isPLP'
        ? `${props.theme.fonts.fontSize.body.bodytext.copy2}px`
        : `${props.theme.fonts.fontSize.body.bodytext.copy3}px`};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) =>
        props.className === 'isPLP'
          ? `${props.theme.fonts.fontSize.body.bodytext.copy1}px`
          : `${props.theme.fonts.fontSize.body.bodytext.copy2}px`};
    }
    color: ${colorPalette};
    cursor: pointer;
  }
`;

export const StyledGimme20Price = Styled.span`
  font-weight: 800;
  color: #c8102e;

  &.pickup-store-modal-promotions {
      font-size: 14px !important;
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 12px !important;
    }
    }
`;

export default PromotionContainer;
